import { IActivityFilterItem, IStreamFilter } from 'redhotpie-shared-lib/interfaces/IStream';

interface StreamObject {
  ActivityFilters?: string[];
}

const USER_ACTIVITY_FILTERS: { [key: string]: number } = {
  Events: 1,
  Forums: 2,
  Stories: 4,
  ProfilePhotos: 8,
  Articles: 16,
  Validations: 32,
  Galleries: 64,
  Videos: 128,
  Groups: 256,
};

export default class StreamSettings {
  activityFilters: IActivityFilterItem[];

  constructor() {
    this.activityFilters = [];
  }

  static mappingObject(_obj: StreamObject): IStreamFilter {
    const obj = new StreamSettings();
    obj.activityFilters = this.mappingActivityFilters(_obj?.ActivityFilters || []);

    return obj;
  }

  static mappingActivityFilters(_activityFilters: string[]): IActivityFilterItem[] {
    let listDefault: IActivityFilterItem[] = [
      { id: 1, value: 'HomeScreen.Events', isSelected: false, key: 'Events' },
      { id: 2, value: 'HomeScreen.Forums', isSelected: false, key: 'Forums' },
      { id: 4, value: 'HomeScreen.Stories', isSelected: false, key: 'Stories' },
      { id: 8, value: 'HomeScreen.ProfilePhotos', isSelected: false, key: 'ProfilePhotos' },
      { id: 16, value: 'HomeScreen.Articles', isSelected: false, key: 'Articles' },
      { id: 32, value: 'HomeScreen.Validations', isSelected: false, key: 'Validations' },
      { id: 64, value: 'HomeScreen.Galleries', isSelected: false, key: 'Galleries' },
      { id: 128, value: 'HomeScreen.Videos', isSelected: false, key: 'Videos' },
      { id: 256, value: 'HomeScreen.Groups', isSelected: false, key: 'Groups' },
    ];
    let isAll = true;
    _activityFilters.forEach(item => {
      const index = listDefault.findIndex(filter => filter.key === item);
      listDefault[index].isSelected = true;
      isAll = false;
    });
    if (isAll) {
      listDefault = listDefault.map(item => ({ ...item, isSelected: true }));
    }

    return listDefault;
  }
}
